import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const trackEvent = (event, parameters = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...parameters });
};

const Analytics = () => {
  const location = useLocation();
  const initialPage = useRef(true);

  useEffect(() => {
    // The Google tag records the initial load. Only push subsequent React route changes.
    if (initialPage.current) {
      initialPage.current = false;
      return;
    }
    trackEvent("virtual_page_view", {
      page_location: window.location.href,
      page_path: `${location.pathname}${location.search}`,
      page_title: document.title,
    });
  }, [location]);

  useEffect(() => {
    const trackLink = (event) => {
      const link = event.target.closest("a");
      if (!link) return;

      const href = link.getAttribute("href") || "";
      const context = link.closest("header") ? "header" : link.closest("footer") ? "footer" : "page";
      const common = { link_location: context, page_path: window.location.pathname };

      if (href.startsWith("tel:")) trackEvent("phone_click", common);
      else if (href.startsWith("sms:")) trackEvent("text_click", common);
      else if (href.startsWith("mailto:")) trackEvent("email_click", common);
      else if (href.includes("/pdf/product-catalog.pdf")) trackEvent("catalog_download", common);
    };

    document.addEventListener("click", trackLink);
    return () => document.removeEventListener("click", trackLink);
  }, []);

  return null;
};

export default Analytics;
